"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBase64UrlEncodedCodeVerifier = exports.bufferToBase64UrlEncoded = exports.urlEncodeBase64 = exports.sha256 = void 0;
var base64_1 = require("./base64");
var sha256 = function (message) {
    var encoder = new TextEncoder();
    var data = encoder.encode(message);
    return window.crypto.subtle.digest('SHA-256', data);
};
exports.sha256 = sha256;
var urlEncodeBase64 = function (input) {
    var chars = { '+': '-', '/': '_', '=': '' };
    return input.replace(/[+/=]/g, function (m) { return chars[m]; });
};
exports.urlEncodeBase64 = urlEncodeBase64;
var bufferToBase64UrlEncoded = function (input) {
    var bytes = new Uint8Array(input);
    return exports.urlEncodeBase64(base64_1.encode(String.fromCharCode.apply(String, __spreadArray([], __read(bytes)))));
};
exports.bufferToBase64UrlEncoded = bufferToBase64UrlEncoded;
var getBase64UrlEncodedCodeVerifier = function (verifierStr) {
    if (verifierStr === void 0) { verifierStr = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var shaBuffer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, exports.sha256(verifierStr)];
                case 1:
                    shaBuffer = _a.sent();
                    return [2, exports.bufferToBase64UrlEncoded(shaBuffer)];
            }
        });
    });
};
exports.getBase64UrlEncodedCodeVerifier = getBase64UrlEncodedCodeVerifier;
//# sourceMappingURL=codeVerifier.js.map